import type { History } from 'history';

/** In-app paths use same-tab navigation; http(s) opens a new tab. */
export function openSidebarRedirectionLink(url: string | undefined, history: History) {
  if (!url) return;
  if (/^https?:\/\//i.test(url)) {
    window.open(url, '_blank', 'noopener,noreferrer');
  } else {
    history.push(url);
  }
}
